import * as t from "./actionTypes";
import { userService } from "client-app-core";

import keys from "lodash/keys";
import get from "lodash/get";

// AppState selectors are already imported and used in GlobalData selectors. Importing any selector from GlobalData would cause a circular dependency issue. To avoid this, we are exporting the required selector from the actions file.
export { feedEntitiesGeoByTypeSelector } from "orion-components/GlobalData/Selectors";

/*
 * Set persisted app state from DB
 * @params appState: app state object
 */
const appStateReceived = appState => {
	return {
		type: t.APP_STATE_RECEIVED,
		payload: { appState }
	};
};

/*
 * Get persisted app state from DB
 * @params app: app name string
 */
export const getAppState = app => {
	return dispatch => {
		return new Promise(resolve => {
			userService.getAppState(app, (err, result) => {
				if (err) console.log(err);
				else {
					dispatch(
						appStateReceived({
							...result.state
						})
					);
					resolve();
				}
			});
		});
	};
};

/*
 * Set app state from caller - for offline usage, i.e. standalone replay
 * @params app: app name string
 * @params state: app state object
 */
export const setAppState = state => {
	return dispatch => {
		dispatch(
			appStateReceived({
				...state
			})
		);
	};
};

/*
 * Update persisted app state in local state
 * @params keyVal: an object with a key-value pair to update in the local state (ex: { mapZoom: 11 })
 */
export const setLocalAppState = (key, value) => {
	return {
		type: t.SET_LOCAL_APP_STATE,
		payload: {
			key,
			value
		}
	};
};

/*
 * Update persisted app state in DB and local state
 * @params app: app name string
 * @params key: an object key string to update in the DB and local state
 * @params value: an object value to update in the DB and local state
 * @params reliable: if set to true, the local state would be updated only after the persistence
 *                   on server is successful. Default value is true.
 */
export const updatePersistedState = (app, key, value, reliable = true, isValStringOrArray = false) => {
	return (dispatch, getState) => {
		let update = null;
		if (isValStringOrArray) {
			update = value;
		} else {
			// Check to see if we are updating a nested object
			const isNested = !keys(value).includes(key);
			const oldValue = getState().appState.persisted[key];
			// If not updating a nested object, only return the value
			update = isNested ? { ...(oldValue || value), ...value } : get(value, key);
			if (!reliable) {
				// We update the local state straight-away
				dispatch(setLocalAppState(key, update));
			}
		}

		userService.setAppState(app, { [key]: update }, (err, result) => {
			if (err) {
				console.log(err, result);
			} else {
				if (reliable) {
					dispatch(setLocalAppState(key, update));
				}
			}
		});
	};
};
